export default __webpack_public_path__ + "static/media/timer_xl2.6d95ded4.png";